import { Button, styled, ButtonProps } from "@mui/material";

export interface CustomButtonProps {
  text?: string;
  width?: string;
  variant?: "outlined" | "contained";
  type?: "submit" | "reset";
  bgcolor?: string;
  height?: string;
  paddingLeft?: string;
  paddingRight?: string;
  color?: string;
  onClick?: () => void;
  deleteBtn?: any;
  disableButton?: true | false;
  disableBtnColor?: string;
  disableBtnbgColor?: string;
  minWidth?: string;
}

export interface StyledButtonProps extends ButtonProps {
  width?: string;
  variant?: "outlined" | "contained";
}
//Custom Button
const ButtonStyle: React.FC<CustomButtonProps> = ({
  text,
  variant = "contained",
  width = "auto",
  height = "33px",
  type,
  bgcolor = "var(--color-steelblue)",
  paddingLeft ="var(--padding-41xl)",
  paddingRight ="var(--padding-41xl)",
  color = "var(--color-white)",
  onClick,
  deleteBtn,
  disableButton =false,
  disableBtnColor="#C4C4C4",
  disableBtnbgColor="#F3F7FA",
  minWidth = '64px'
}) => {
  //Button Style
  const StyledButton = styled(Button)<StyledButtonProps>(() => ({
    fontFamily: "var(--font-inter)",
    whiteSpace: 'nowrap',
    fontSize: "var(--font-size-xs)",
    fontWeight: 600,
    cursor: "pointer",
    border: "0",
    paddingLeft: paddingLeft,
    paddingRight: paddingRight,
    backgroundColor: bgcolor,
    borderRadius: "var(--br-xl)",
    height: height,
    width: width,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    boxSizing: "border-box",
    textTransform: "none",
    color: color,
    minWidth: minWidth,
    '&:hover': {
        backgroundColor: bgcolor,
        color: color,
        outline: 'none',
        border: 'none'
    },
    '&:disabled': {
      cursor: 'not-allowed',
      backgroundColor: disableBtnbgColor,
      color: disableBtnColor
    }
  }));

  return (
    <StyledButton disabled={disableButton} variant={variant} disableElevation={true} onClick={onClick} disableRipple width={width} type={type}>
      {deleteBtn ? deleteBtn : text}
    </StyledButton>
  );
};

export default ButtonStyle;
